/**
 * Gedeelde helpers voor toernooifase/wedstrijd selectie.
 *
 * Gebruikt door AdminGame (Transferrondes) en, voor de vertaalde fasenamen, door
 * de kalender. Kalender & rondes zelf kiest geen fase meer met dropdowns: die
 * pagina leest de rondes uit `schedule/{seasonId}/rounds`.
 */

export const translatedStageNames = {
    'Regular Season': 'Competitie',
    'Group Stage': 'Groepsfase',
    'League Stage': 'Poulefase',
    'Qualification Round': 'Kwalificatieronde',
    'Knockout Round Play-offs': 'Tussenronde',
    '8th Finals': 'Achtste finale',
    'Quarter-finals': 'Kwartfinale',
    'Semi-finals': 'Halve finale',
    'Final': 'Finale'
};

/**
 * Vertaalt een Sportmonks stage name naar het Nederlands.
 */
export const getTranslatedStageName = (name) => {
    if (!name) return name;
    for (const key in translatedStageNames) {
        if (name.startsWith(key)) {
            return name.replace(key, translatedStageNames[key]);
        }
    }
    return name;
};

/**
 * Bepaalt of een stage de League Stage is (op basis van stages array en selectedStage id).
 */
export const isLeagueStage = (stages, selectedStage) => {
    return stages.find(s => s.id === selectedStage)?.name === 'League Stage';
};

/**
 * Berekent het gecombineerde storage ID voor een toernooifase/wedstrijd selectie.
 * Voor League Stage: het geselecteerde ronde-ID.
 * Voor knockout stages: `${stageId}-${leg || '1'}`.
 */
export const getEffectiveStorageId = (stages, selectedStage, selectedRound, selectedLeg) => {
    if (isLeagueStage(stages, selectedStage)) {
        return selectedRound;
    } else {
        return `${selectedStage}-${selectedLeg || '1'}`;
    }
};

/**
 * Genereert een leesbare naam voor de toernooifase/wedstrijd combinatie.
 */
export const getMatchDisplayName = (stages, selectedStage, rounds, selectedRound, selectedLeg) => {
    const stage = stages.find(s => s.id === selectedStage);
    const stageName = getTranslatedStageName(stage?.name) || 'Onbekend';

    if (isLeagueStage(stages, selectedStage)) {
        const round = rounds.find(r => r.id === selectedRound);
        return `${stageName} — ${round?.name || 'Onbekend'}`;
    } else {
        return `${stageName} — Wedstrijd ${selectedLeg || '1'}/2`;
    }
};
